import { API_BASE_URL } from '../../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchIncoterms = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const createIncoterm = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateIncoterm = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteIncoterm = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleIncotermStatus = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/incoterms/${id}/toggle-status`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};

export const exportIncoterms = async ({ query = {}, sort } = {}) => {
  return fetchIncoterms({ limit: 10000, offset: 1, query, sort });
};
